import React from 'react';
import AvatarMui from '@material-ui/core/Avatar';

import { getInitials } from 'helpers';
import { IAvatarProps } from './types';

const Avatar = ({ username, src, ...props }: IAvatarProps) => (
  <AvatarMui src={src} {...props}>
    {getInitials(username)}
  </AvatarMui>
);

export default Avatar;
